import classNames from 'classnames'
import { memo } from 'react'

import { eventLineText } from 'features/TeamChat/api/teamChat.transform'
import type { TeamMember, TeamMessage } from 'features/TeamChat/api/teamChat.types'
import { TEAM_COPY } from 'features/TeamChat/teamChat.constants'
import styles from 'features/TeamChat/teamChat.module.scss'

import { MemberAvatar } from '../MemberAvatar'
import { MentionText } from '../MentionText'

// The site-zone time comes precomputed from MessageList.
type Props = { message: TeamMessage; members: TeamMember[]; time: string; enter?: boolean }

const MessageItemView = ({ message, members, time, enter }: Props) => {
  const motionClass = enter ? styles.enter : undefined
  if (message.type === 'event')
    return (
      <div className={classNames(styles.event, motionClass)}>{`${eventLineText(
        message,
      )} · ${time}`}</div>
    )
  const bubble = (
    <div
      className={classNames(styles.bubble, {
        [styles.bubbleMine]: message.is_mine,
        [styles.bubbleMentionsMe]: !message.is_mine && message.mentions_me,
      })}>
      <MentionText text={message.body} members={members} />
    </div>
  )
  if (message.is_mine)
    return (
      <div
        className={classNames(styles.bubbleWrap, styles.mine, motionClass, {
          [styles.pending]: message.pending,
        })}
        aria-busy={message.pending || undefined}>
        <div className={styles.bubbleMeta}>
          {message.pending ? TEAM_COPY.SENDING : `You · ${time}`}
        </div>
        {bubble}
      </div>
    )
  return (
    <div className={classNames(styles.other, motionClass)}>
      <MemberAvatar user={message.user} size={28} />
      <div className={styles.bubbleWrap}>
        <div className={styles.bubbleMeta}>{`${message.user.name} · ${time}`}</div>
        {bubble}
      </div>
    </div>
  )
}

export const MessageItem = memo(MessageItemView)
